import React from 'react'
import { Link } from 'react-router-dom'

const navigation = {
  company: [
    { name: 'About', to: '/about' },
    { name: 'Pricing', to: '/pricing' }
  ],
  resources: [
    { name: 'Terms', to: '/terms' },
    { name: 'Disclaimer', to: '/disclaimer' },
    { name: 'Refunds', to: '/refunds' }
  ],
  footerLinks: [
    { name: 'Terms', to: '/terms' },
    { name: 'Privacy Policy', to: '/disclaimer' },
    { name: 'Cookies', to: '/cookie-policy' },
    {
      name: 'DSAR Form',
      href: 'https://app.termly.io/notify/572cfd77-b3c3-4241-9dca-16acc37d2d61'
    },
    {
      name: 'Do Not Sell My Info',
      href: 'https://app.termly.io/notify/572cfd77-b3c3-4241-9dca-16acc37d2d61'
    }
  ]
}

function MarketingPageFooter() {
  return (
    <footer className="w-full bg-white dark:bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <Link to="/" className="text-2xl text-purple-600 dark:text-purple-500 font-wordmark font-bold">
              Leevo
            </Link>
            <div className="w-full md:w-2/3">
              <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">Management software that actually works.</p>
              <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                By supporting Leevo, you&apos;re not paying money to a faceless corporation. You are supporting our
                livelihood and advancing the sports you love.
              </p>
            </div>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-4">Company</h3>
            <ul className="space-y-3">
              {navigation.company.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.to}
                    className="text-sm text-gray-600 hover:text-purple-600 dark:text-gray-400 dark:hover:text-purple-400 transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-4">Resources</h3>
            <ul className="space-y-3">
              {navigation.resources.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.to}
                    className="text-sm text-gray-600 hover:text-purple-600 dark:text-gray-400 dark:hover:text-purple-400 transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-700">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-4">
              &copy; {new Date().getFullYear()} Leevo, LLC. All rights reserved.
            </p>
            <div className="flex flex-wrap gap-x-6 gap-y-2">
              {navigation.footerLinks.map((item) => (
                <div key={item.name}>
                  {item.to ? (
                    <Link
                      to={item.to}
                      className="text-sm text-gray-500 hover:text-purple-600 dark:text-gray-400 dark:hover:text-purple-400 transition-colors"
                    >
                      {item.name}
                    </Link>
                  ) : (
                    <a
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-gray-500 hover:text-purple-600 dark:text-gray-400 dark:hover:text-purple-400 transition-colors"
                    >
                      {item.name}
                    </a>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default MarketingPageFooter
